import React from 'react';

const Navbar = () => {
  const admin = {
    name: 'Hasnain Ali',
    role: 'Admin'
  };

  return (
    <nav className="navbar">
      <div className="navbar-title">Admin Panel</div>
      <div className="navbar-profile">
        <span className="admin-name">{admin.name}</span>
        <div className="profile-circle">{admin.name.charAt(0)}</div>
      </div>
    </nav>
  );
};

export default Navbar;
